import React, { useState } from "react";
import Modal from "react-modal";
import Lightbox from "react-image-lightbox";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import imagesLoaded from "imagesloaded";
import ProductDetailOne from "../../../pages/products/partials/details/detail-one";

import OwlCarousel from "../../owl-carousel";

import {
  addToCart,
  toggleWishlist,
  closeQuickViewModal,
} from "../../../../actions";
import { findIndex, quantityInputs, productGallery } from "../../../../utils";
// import MediaOne from "../../../pages/products/partials/media/media-one";

const customStyles = {
  content: {
    top: "50%",
    transform: "translateY(-50%)",
  },
  overlay: {
    backgroundColor: "rgba(51,51,51,0.6)",
    zIndex: "10000",
  },
};

Modal.setAppElement("#root");

function QuickView(props) {
  const { showModal, productDetail, closeQuickViewModal } = props;
  const [photoIndex, setIndex] = useState(0);
  const [open, setOpen] = useState(false);

  React.useEffect(() => {
    productGallery();
  });

  function openLightBox(index) {
    setIndex(index);
    setOpen(true);
  }

  function afterOpenModal() {
    quantityInputs();
    let imgLoad = imagesLoaded(".product-lg", { background: true });

    imgLoad.on("done", function (instance, image) {
      document
        .querySelector(".skel-pro-single.skel-quickview")
        .classList.add("loaded");
    });
  }

  function preventNav(e) {
    e.preventDefault();
  }

  // const addToCartHandler = () => {
  //   if (productDetail.stock > 0) {
  //     addToCart(productDetail, document.querySelector("#qty-quickview").value);
  //   }
  // };

  const closeQuickViewModalHandler = () => {
    closeQuickViewModal();
  };

  // const toggleWishlistHandler = () => {
  //   toggleWishlist(productDetail, props.wishlist);
  // };

  const closeLightBoxHandler = () => {
    setOpen(false);
  };

  const setNextHandler = () => {
    setIndex((photoIndex + images.length - 1) % images.length);
  };

  const setPrevHandler = () => {
    setIndex((photoIndex + 1) % images.length);
  };

  if (!productDetail || !productDetail.name) return "";

  // let ratings = productDetail.ratings * 20;
  let images = productDetail.lgPictures
    ? productDetail.lgPictures
    : productDetail.pictures;
  let smallPictures = productDetail.smPictures
    ? productDetail.smPictures
    : productDetail.pictures;

  return (
    <Modal
      isOpen={showModal}
      contentLabel="QuickView"
      onAfterOpen={afterOpenModal}
      onRequestClose={closeQuickViewModal}
      shouldFocusAfterRender={false}
      style={customStyles}
      className="container quickView-container"
      id="product-quickview"
    >
      <div className="quickView-content horizontal skeleton-body">
        <div className="row skel-pro-single skel-quickview">
          <div className="col-lg-6 p-0">
            <div className="skel-product-gallery"></div>

            <div className="product-lg mb-1">
              <OwlCarousel
                adClass="owl-quickview cols-1"
                carouselOptions="{dots: false, nav: false, loop: true, autoPlay: false, dotsContainer: #owl-dots}"
                id="owl_quickview"
                carouselId="quickView"
              >
                {images.map((item, index) => (
                  <div
                    className="intro-slide bg-transparent"
                    key={"gallery" + index}
                  >
                    <img src={item} alt="Desc" />
                    <button
                      className="btn-fullscreen"
                      onClick={() => openLightBox(index)}
                    >
                      <i className="icon-arrows"></i>
                    </button>
                  </div>
                ))}
              </OwlCarousel>
              {/* <MediaOne id={productDetail.id} /> */}
            </div>

            <div className="product-sm row" id="owl-dots">
              {smallPictures.map((item, index) => (
                <Link
                  onClick={preventNav}
                  to="#"
                  className={`carousel-dot d-block ${
                    0 === index ? "active" : ""
                  }`}
                  key={"product-dot-" + index}
                >
                  <img src={item} alt="dot" />
                </Link>
              ))}
            </div>
          </div>

          <div className="col-lg-6 quickview-desc">
            {/* <div className="entry-summary row">
              <div className="col-md-12">
                <div className="entry-summary1"></div>
              </div>

              <div className="col-md-12">
                <div className="entry-summary2"></div>
              </div>
            </div> */}

            <div className="product-real-detail">
              <ProductDetailOne id={productDetail.id} />
            </div>
          </div>
        </div>
      </div>

      <button
        title="Close (Esc)"
        type="button"
        className="mfp-close"
        onClick={closeQuickViewModalHandler}
      >
        <span>×</span>
      </button>

      {open && (
        <Lightbox
          mainSrc={images[photoIndex]}
          nextSrc={images[(photoIndex + 1) % images.length]}
          prevSrc={images[(photoIndex + images.length - 1) % images.length]}
          onCloseRequest={closeLightBoxHandler}
          onMovePrevRequest={setNextHandler}
          onMoveNextRequest={setPrevHandler}
        />
      )}
    </Modal>
  );
}

const mapStateToProps = (state, ownprops) => {
  let wishlist = false;

  if (
    findIndex(
      state.wishlist.list,
      (item) => item.id === state.data.productDetail.id
    ) !== -1
  )
    wishlist = true;

  return {
    showModal: state.data.quickView,
    productDetail: state.data.productDetail,
    wishlist: wishlist,
  };
};

export default connect(mapStateToProps, {
  addToCart,
  toggleWishlist,
  closeQuickViewModal,
})(QuickView);
